export const FETCH_GENERIC_PROPERTY = 'mac/FETCH_GENERIC_PROPERTY';
